<template>
  <div class="accordion">
    <div class="card">
      <div class="card-header " id="headingOne">
        <div class="btn col-md-8 offset-md-2" @click="toggle">
          <div class="btn-left">
            <span class="iconfont" style="font-size:23px">&#xe61b;</span>
            <em>{{$t('shopping.show')}}</em>
            <strong>{{$t('shopping.hide')}}</strong> {{$t('shopping.order_summary')}}
            <em class="iconfont iconfont_xia" style="font-size: 12px;">&#xe63c;</em>
            <strong class="iconfont iconfont_shang" style="font-size: 13px;">&#xe682;</strong>
          </div>
          <div class="btn-right">
            <div
              v-if="coupons.length"
            ><v-currencysymbol></v-currencysymbol>{{((computedTotal-0)+(discount_cart-0)).toFixed(2)}}</div>
            <i><v-currencysymbol></v-currencysymbol>{{computedTotal}}</i>
          </div>
          <!-- <i>
            ${{this.$store.state.order_shipping?}}
          </i>-->
        </div>
      </div>
      <div class="collapse" style="border-top:1px solid #E6E6E6">
        <div class="card-body">
          <div class="col-md-8 offset-md-2" style="padding:0px;">
            <v-checkoutright :order_tip_img='order_tip_img'  :order_tip='order_tip' :orders_query="orders_query" :cart="cart"></v-checkoutright>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["cart", "orders_query",'order_tip','order_tip_img'],
  data() {
    return {
      order_total: 0, //总价
      order_subtotal: 0, //折扣前总价
      order_shipping: 0, //最终运费
      coupons: [], //优惠券列表
      order_insurance_price: 0, //运费险
      discount_cart: 0, //优惠力度
    };
  },
  methods: {
    toggle() {
      this.$(".collapse").stop();
      this.$(".btn em").toggle();
      this.$(".btn strong").toggle();
      this.$(".collapse").slideToggle(300);
    }
  },
  computed:{
    computedTotal(){
      let cartTotal=this.order_total;
      if(this.$store.state.order_shipping!==''&&this.cart.shipping&&this.cart.shipping.chosen_method){
        cartTotal=cartTotal-this.order_shipping+this.$store.state.order_shipping;
      }else if(this.$store.state.order_shipping!==''){
        cartTotal+=this.$store.state.order_shipping;
      }
      if(this.$store.state.shipping_insurance_price!==''&&this.cart.shipping_insurance){
        cartTotal=cartTotal-this.order_insurance_price+this.$store.state.shipping_insurance_price;
      }else if(this.$store.state.shipping_insurance_price!==''){
        cartTotal=cartTotal+this.$store.state.shipping_insurance_price
      }
      return (cartTotal-0).toFixed(2);
    }
  },
  mounted() {
    if (this.cart.ID) {
      this.order_total = this.cart.order_total-0;
      this.order_shipping = this.cart.order_shipping-0;
      this.order_subtotal = this.cart.order_total - this.cart.order_shipping;
      //thank页面的百分比优惠券已经是计算后的
      this.cart.coupons.forEach(item => {
        this.discount_cart += item.discount_amount - 0;
        this.order_subtotal += item.discount_amount - 0;
        //购物车页面和thank页面的字段不一样
        this.coupons.push({
          code: item.order_item_name,
          amount: item.discount_amount
        });
      });
      if (this.cart.fees[0]) {
        this.order_insurance_price = this.cart.fees[0].line_total;
      }
    } else {
      this.order_subtotal = this.cart.cart_subtotal;
      this.order_total = this.cart.cart_total;
      this.order_shipping = this.cart.shipping_total;
      //购物车获取到的优惠券信息是对象的格式
      this.coupons = Object.values(this.cart.coupons);
      if (this.cart.fees["shipping-insurance"]) {
        this.order_insurance_price = this.cart.fees["shipping-insurance"].total;
      }
      this.discount_cart = this.cart.discount_cart;
    }
  },
  watch: {
    "$store.state.news_cart"() {
      this.coupons = Object.values(this.$store.state.news_cart.coupons);
      this.order_subtotal = this.cart.cart_subtotal;
      this.order_total = this.$store.state.news_cart.cart_total;
      this.order_shipping = this.$store.state.news_cart.shipping_total;
      this.discount_cart = this.$store.state.news_cart.discount_cart;
      console.log(this.$store.state.news_cart);
    }
  }
};
</script>
<style scoped lang='scss'>
.accordion {
  display: none;
  margin-bottom: 21px;
  .card {
    background: #fafafa;
    border-right: none;
    border-left: none;
  }

  #headingOne {
    background: #fafafa;
    padding: 0;
    .btn {
      text-align: left;
      width: 100%;
      color: #0f88a7;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 15px;
      .btn-right {
        vertical-align: middle;
        text-align: right;
        div {
          font-size: 12px;
          color: #737373;
          text-decoration: line-through;
          margin-bottom: -5px;
        }
        i {
          white-space: nowrap;
          display: inline-block;
          font-style: normal;
          color: #333333;
          font-size: 18px;
        }
      }

      .btn-left {
        font-size: 13px;
        vertical-align: top;
        span{
          vertical-align: middle;
        }
        em,
        strong {
          font-style: normal;
          font-weight: normal;
        }
        em {
          display: inline-block;
        }
        strong {
          display: none;
        }
        .iconfont_xia,
        .iconfont_shang {
          font-weight: 600;
          vertical-align: middle;
          margin-left: -3px;
        }
      }
    }
  }
}

@media screen and (max-width: 991px) {
  .accordion {
    display: block !important;
  }
}
</style>